<script setup lang="ts">
const props = defineProps<{ dates: Date[] }>()

const date = computed(() => props.dates[0])
</script>

<template>
  <figure v-if="date" class="-gap-12 flex max-w-fit flex-col items-center rounded-2xl bg-white p-4 pt-2 xs:min-w-28">
    <span v-if="dates.length === 1" class="text-3xl xs:text-6xl">{{ date.getDate() }}</span>
    <IconsGraphicsStarIcon
      v-else
      aria-hidden="true"
      class="my-4 scale-125"
    />
    <span class="text-lg uppercase">{{ date.toLocaleDateString("no-NO", { month: "short" }) }}</span>
  </figure>
</template>
